'use strict';

const {
  bindToggleDrawers,
} = require('../../deal/responsive/frontend/bind_toggle_drawers');

const FinePrint = {
  optionSpecificFinePrint(finePrint) {
    const $finePrintDesc = document.querySelector('.fine-print-description');
    if (!$finePrintDesc) {
      return;
    }

    if (!window.BuyButtonEventPipe) {
      return;
    }

    window.BuyButtonEventPipe.on('option_clicked', ({ $option }) => {
      const { uuid } = $option.dataset;

      if (finePrint && finePrint.optionSpecificDescriptions[uuid]) {
        $finePrintDesc.innerHTML = finePrint.optionSpecificDescriptions[uuid];
      }
    });
  },

  init({ finePrint }, done) {
    bindToggleDrawers();
    this.optionSpecificFinePrint(finePrint);
    return done();
  },
};

module.exports = FinePrint;
